var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    ref: "item",
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_vm.message.type == _vm.CHAT_MESSAGE_TYPES.PROMPT_ALERT.value ? [_c('item-alert', _vm._b({}, 'item-alert', {
    messages: _vm.messages,
    message: _vm.message
  }, false))] : _vm._e(), _vm.message.type == _vm.CHAT_MESSAGE_TYPES.PROMPT_QUERY.value ? [_c('item-query', _vm._b({}, 'item-query', {
    messages: _vm.messages,
    message: _vm.message,
    index: _vm.index
  }, false))] : _vm._e(), _vm.message.type == _vm.CHAT_MESSAGE_TYPES.PROMPT_REPLY.value ? [_c('item-reply', _vm._b({}, 'item-reply', {
    messages: _vm.messages,
    message: _vm.message,
    index: _vm.index
  }, false))] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }